import { SyncState } from '@sonar-software/xuder';
import { UserReference } from '../../../@types';

export type SonarUserIdMapState = SyncState<Record<number, UserReference>>;

export const defaultUserIdMapState: SonarUserIdMapState = { data: {} };
